<template>
    <option value="b9f07f5c-d4f6-4224-8573-98ddfffa3fe2">US 915MHz OTAA 1.0.x</option>
</template>
